import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent {

  constructor(
    public fb: FormBuilder,
    public router: Router
  ) { }

  @Output() onCancel = new EventEmitter();

  public formGroup: FormGroup

  ngOnInit(): void {
    this.initFormGroup()
  }

  initFormGroup() {
    this.formGroup = this.fb.group({
      login: [ "", Validators.required ]
    })
  }

  submitForm() {
    
  }
}
